import {useMutation} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import {Base64ObjectInput, Question} from '@cp/model';
import {CREATE_QUESTION_FROM_STRING} from '../sharedQueries';

export function useCreateQuestionFromString() {
  const [createQuestionFromStringMutation, {loading, error}] = useMutation<
    {createQuestionFromString: Question},
    {
      moduleId: string;
      topic: string;
      questionJsonString: string;
      image?: Base64ObjectInput | null;
      skipFormat?: boolean;
      seedQuestionId?: string;
    }
  >(CREATE_QUESTION_FROM_STRING);

  const createQuestionFromString = async (
    moduleId: string,
    topic: string,
    questionJsonString: string,
    image?: Base64ObjectInput | null,
    skipFormat?: boolean,
    seedQuestionId?: string,
  ) => {
    const result = await createQuestionFromStringMutation({
      variables: {
        moduleId,
        topic,
        questionJsonString,
        image: image || undefined,
        skipFormat,
        seedQuestionId,
      },
    });

    return extractGqlData(result).createQuestionFromString;
  };

  return {
    createQuestionFromString,
    loading,
    error,
  };
}
